/**
 * Single name token: first character uppercase, remaining characters lowercase.
 */
export function formatNameToken(token: string): string {
  const t = token.trim();
  if (!t) return '';
  return t.charAt(0).toLocaleUpperCase() + t.slice(1).toLocaleLowerCase();
}

/**
 * Formats a name value that may contain multiple words (e.g. "MARY jane" → "Mary Jane").
 */
export function formatPersonNameField(value: unknown): string {
  if (value === null || value === undefined) return '';
  const s = String(value).trim();
  if (!s) return '';
  return s.split(/\s+/).map(formatNameToken).join(' ');
}

/**
 * Same as {@link formatPersonNameField}, but empty string becomes `null` (optional nullable name fields).
 */
export function formatOptionalPersonNameField(value: unknown): string | null {
  const f = formatPersonNameField(value);
  return f === '' ? null : f;
}
